<template>
  <div class="product-dialog">
    <Dialog width="70%" :scrollable="false" @destroyDialog="handleEvent">

      <template slot="title">
        <div class="main-row justify-center">
          <span class="title">Select Product</span>
        </div>
      </template>

      <template slot="body">
        <div class="main-row">
          <div class="protocols__total d-flex align-center mr-10"><span class="num mr-2">{{total}}</span> Products</div>
          <div class="d-flex align-center flex-grow-1 justify-end">
            <div class="mr-4" style="display: flex;align-items: center;gap: 20px;">
              <div style="display: flex;align-items: center;gap: 10px;">
                <div style="width: 10px;height: 10px;border-radius: 50%;background: #e7e7e7"></div>
                <span>Discontinued</span>
              </div>
              <div style="display: flex;align-items: center;gap: 10px;">
                <div style="width: 10px;height: 10px;border-radius: 50%;background: #008c725c"></div>
                <span>Default</span>
              </div>
            </div>
            <Input class="mr-2"
                   style="margin-top: 17px"
                   outlined
                   radius="8"
                   placeholder="Search"
                   @input="inputSearch"
                   :value="searchedText"
                   @enter="getProducts(query)"
            >
              <div slot="append" style="cursor: pointer" @click="getProducts(query)">
                <v-icon>mdi-magnify</v-icon>
              </div>
            </Input>
            <Button btn-bg="dark-green"
                    class="mr-2"
                    @click="refresh"
                    :styles="{'border-radius': '8px'}"
            >
                <span style="color: #FFFFFF">
                  Refresh
                </span>
            </Button>
          </div>
        </div>
        <div class="main-row" style="position:relative;">
          <Table
            :headers="headers"
            :items="itemsProducts"
            class="product-table"
            ref="productTable"
            @update:option="optionTableData($event, 'asc')"
            @filterBox="filterBox"
            @resetFilter="resetFilter"
            hideDefaultFooter><!--v-if="protocols.headers"-->

            <template v-slot:body>
              <template v-for="(item) in itemsProducts">
                <tr
                  :key="item.id"
                  class="product-table__row"
                  :class="{ 'is-discontinued': item.isDiscontinued, 'is-default': item.isDefault }"
                  @click="toggleRow(item.id)"
                >
                  <td class="name px-3 pt-1 pb-1"><!--:style="{'width': (item.supplementName.length * 8) + 'px'}"-->
                    <div class="d-flex align-center width100 height100 justify-space-between">
                      <div class="name d-flex align-center">
                        <span class="font-weight-bold" v-if="!searchedText">{{item.name }}</span>
                        <span class="font-weight-bold" v-else v-html="highlightSearchedText(item.name, searchedText)"></span>
                        <v-tooltip top v-if="item.organizationId">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="blue" v-bind="attrs" v-on="on">mdi-account-check</v-icon>
                          </template>
                          <span>This is my custom product</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </td>
                  <td class="notes px-3 pt-1 pb-1">
                    <div class="d-flex align-center width100 height100">
                      <span class="font-weight-bold">{{item.productNumber }}</span>
                    </div>
                  </td>
                  <td class="notes px-3 pt-1 pb-1">
                    <div class="d-flex align-center width100 height100">
                      <span class="font-weight-bold">${{item.listPrice.toFixed(2) }}</span>
                    </div>
                  </td>
                  <td class="notes px-3 pt-1 pb-1">
                    <div class="d-flex align-center width100 height100">
                      <span class="font-weight-bold">{{item.isDefault ? 'Yes' : 'No' }}</span>
                    </div>
                  </td>
                  <td class="notes px-3 pt-1 pb-1">
                    <div class="d-flex align-center width100 height100">
                      <span class="font-weight-bold">{{item.isTaxable ? 'Yes' : 'No' }}</span>
                    </div>
                  </td>
                  <td class="notes px-3 pt-1 pb-1" @click.stop>
                    <div class="d-flex align-center width100 height100">
                      <Button btn-bg="dark-green"
                              @click="selectProduct(item)"
                              :styles="{'border-radius': '8px', 'border': '1px solid #d4d4d4'}">
                        <span style="color: white">Select</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
            <template v-slot:footer>
              <div class="footer pl-5 d-flex align-center">
                <div class="row-per-page d-flex align-center flex-grow-1">
                  <span class="row-per-page__lable mr-4">Rows per page: </span>
                  <Select class="row-per-page__list" radius="8" color="#B5B5BD" :items="rowPerPageItems" :value="rowPerPageItems[2]" @change="changeItermPerPage" />
                </div>
                <div class="flex-grow-2">
                  <pagination v-if="pageCountProtocol" :value="page" :length="pageCountProtocol" :totalVisible="7" @input="changePagination" />
                </div>
                <div class="d-flex align-center justify-end flex-grow-1 mr-6" style="column-gap: 1rem">
                  <v-switch class="py-0 my-0" color="#008C89" inset label="Only Default" @change="onlyDefault" />
                  <v-switch class="py-0 my-0" color="#008C89" inset label="Only Taxable" @change="onlyTaxable" />
                  <v-switch class="py-0 my-0" color="#008C89" inset label="Show Discontinued" @change="showDiscontinued" />
                </div>
              </div>
            </template>
          </Table>
          <div v-if="loading" class="loading d-flex justify-center px-2 py-2 align-center">
            <v-progress-circular
              indeterminate
              color="#008C89"
            ></v-progress-circular>
          </div>
        </div>
      </template>
    </Dialog>
    <confirm v-if="dialogs.confirm.isOpen" :query="query"/>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Pagination from '@/mixins/Pagination'
import Input from '@/components/elements/Input'
import Button from '@/components/elements/Button'
import Table from '@/components/elements/Table'
import pagination from '@/components/layouts/pagination'
import Select from '@/components/elements/Select'
import actions from '@/components/layouts/actions'
import confirm from '@/components/layouts/dialogs/confirm-dialog'
import Dialog from '@/components/layouts/dialog.vue'
import { trackEvent } from '@/utils/analytics'

const GET_ALL_PRODUCTS = 'getProducts'
const IS_SLOTABLE = ['name', 'Discontinued', 'notes', 'active']

export default {
  name: 'product',
  components: { Dialog, Input, Button, Table, pagination, Select, actions, confirm },
  mixins: [Pagination],
  data: () => ({
    searchedText: '',
    itemsPerPage: 15,
    page: 1,
    expandedRows: [],
    supplementDosages: [
      {
        id: 1,
        active: false,
        value: 1,
        text: '1'
      },
      {
        id: 2,
        active: false,
        value: 2,
        text: '2'
      },
      {
        id: 3,
        active: true,
        value: 3,
        text: '3'
      },
      {
        id: 4,
        active: false,
        value: 4,
        text: '4'
      },
      {
        id: 5,
        active: false,
        value: 5,
        text: '5'
      },
      {
        id: 6,
        active: false,
        value: 0,
        text: 'x'
      }
    ],
    supplementDosagesDaysPerWeek: [
      {
        id: 1,
        active: false,
        value: 1,
        text: '1'
      },
      {
        id: 2,
        active: false,
        value: 2,
        text: '2'
      },
      {
        id: 3,
        active: true,
        value: 3,
        text: '3'
      },
      {
        id: 4,
        active: false,
        value: 4,
        text: '4'
      },
      {
        id: 5,
        active: false,
        value: 5,
        text: '5'
      },
      {
        id: 6,
        active: false,
        value: 6,
        text: '6'
      },
      {
        id: 7,
        active: false,
        value: 7,
        text: '7'
      }
    ],
    isStartCreateNewSupProduct: false,
    loading: true
  }),
  mounted () {
    this.loading = true
  },
  beforeDestroy () {
    this.SET_DATA(['productsListIsLoaded', false])
  },
  methods: {
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    ...mapMutations('protocols', ['SET_DATA']),
    ...mapActions('products', ['getProducts', 'addProduct', 'deleteProduct']),
    ...mapActions('receipts', ['createReceiptPreview']),
    handleEvent ($event) {
      this.$emit('updateResult', true)
    },
    async selectProduct(item) {
      console.log('selectProduct', item)
      delete item.$id
      const { id } = this.$route.params
      const resultId = this.visit.resultId
      const clinicProducts = []
      clinicProducts.push({
        ...item,
        supplementProductId: item.id,
        quantity: 1,
        showOnReceipt: true
      })
      console.log(clinicProducts)
      await this.createReceiptPreview({
        form: {
          visitId: id,
          resultId,
          clinicProducts: clinicProducts
        }
      })
      trackEvent(this, 'add_non-supplement_product', 'Invoices', 'Non-Supplement Product Was Added')

      this.TOGGLE_DIALOG({ name: 'dialogShowProduct', isOpen: false })
      /* const res = await this.addProtocol({ id: this.$route.params?.id, protocolId: id })
      if (res.status && res.status === 400) {
        this.$emit('updateResult', true, { error: res.data })
        this.TOGGLE_DIALOG({ name: 'dialogShowProduct', isOpen: false })
      } else {
        this.$emit('updateResult', true, { data: productName })
        this.TOGGLE_DIALOG({ name: 'dialogShowProduct', isOpen: false })
      } */
    },
    filterBox ($event) {
      const columns = []
      columns.push($event)
      this.addUrlParam({ columns })
      this.getProducts(this.query)
    },
    resetFilter ($event) {
      const query = Object.assign({}, this.query)
      const columns = query.columns.filter(el => el.name !== $event)
      this.addUrlParam({ columns })
      this.getProducts(this.query)
    },
    refresh () {
      // const query = Object.assign({}, this.query)
      delete this.query.search
      delete this.query.columns
      this.query.PageIndex = 0
      this.query.PageSize = 15
      this.page = 1
      this.searchedText = ''
      this.addUrlParam({ ...this.query })
      this.$nextTick(() => {
        this.getProducts(this.query)
      })
    },
    goToSettings () {
      if (this.$route.name === 'Settings') {
        this.TOGGLE_DIALOG({ name: 'trialSubscriptionDialog', isOpen: false, root: true })
      } else {
        this.TOGGLE_DIALOG({ name: 'trialSubscriptionDialog', isOpen: false, root: true })
        this.$router.push({ name: 'Settings' })
      }
    },
    inputSearch ($event) {
      this.searchedText = $event
      this.page = 1
      this.addUrlParam({ PageIndex: 0, search: { searchType: 1, value: $event } })
    },
    highlightSearchedText (currentText, searchedText) {
      if (currentText.toLowerCase().includes(searchedText.toLowerCase())) {
        const newStr = currentText.toLowerCase().replace(searchedText.toLowerCase(), `<span style="color: #7cdbc1;">${searchedText}</span>`)
        return newStr
      }
      return currentText
    },
    dynamicSupplementNameMaxWidth (array) {
      let countPixel = 0
      for (let i = 0; i < array.length; i++) {
        countPixel += array[i] ? 13 : 0
      }
      return countPixel
    },
    toggleRow (id) {
      const index = this.expandedRows.indexOf(id)
      if (index > -1) {
        this.expandedRows.splice(index, 1)
      } else {
        this.expandedRows = []
        this.expandedRows.push(id)
      }
    },
    async updateSupplementDosage ({ data, keyProp }) {
      const result = await this.updateResult(data)
      this.updateDataStore(result, keyProp)
    },
    runAction (val) {
      val.params.action(val.id, val)
      // this.editResult(val.id)
    },
    getQuantityBySupplementProductId (resultProducts, productId) {
      const product = resultProducts.find(item => item.supplementProductId === productId)
      return product && product.quantity ? product.quantity : '0'
    },
    changePagination ($event) {
      this.page = $event
      this.addUrlParam({
        PageIndex: $event,
        PageSize: this.itemsPerPage
      })
      this.getProducts(this.query)
    },
    changeItermPerPage ($event) {
      this.itemsPerPage = $event
      if ($event !== this.query.PageSize) {
        this.addUrlParam({
          PageIndex: 0,
          PageSize: $event === 'All' ? '-1' : $event
        })
        this.getProducts(this.query)
      }
    },
    onlyDefault ($event) {
      this.query.PageIndex = 0
      this.addUrlParam({ showOnlyDefault: $event })
      this.page = 1
      this.getProducts(this.query)
    },
    showDiscontinued ($event) {
      this.query.PageIndex = 0
      this.addUrlParam({ showDiscontinued: $event })
      this.page = 1
      this.getProducts(this.query)
    },
    onlyTaxable ($event) {
      this.query.PageIndex = 0
      this.addUrlParam({ showOnlyTaxable: $event })
      this.page = 1
      this.getProducts(this.query)
    },
    async deleteProtocol (id) {
      await this.TOGGLE_DIALOG({
        id,
        name: 'confirm',
        isOpen: true,
        description: 'Are you sure you want to delete the product?',
        action: 'products/deleteProduct',
        afterAction: {
          name: 'products/getProducts',
          product: this.query
        },
        title: 'Confirm deleting the product'
      })
    },
    editProductDialog (id, data) {
      console.log('editProductDialog', id, data)
      this.TOGGLE_DIALOG({
        id,
        name: 'editProductDialog',
        isOpen: true,
        title: 'Edit product',
        afterAction: {
          name: 'products/getProducts',
          product: this.query
        },
        data: data.data
      })
    },
    addSupplement (data) {
      console.log('addSupplement', data)
      this.TOGGLE_DIALOG({
        protocolId: data.id,
        name: 'addSupplementDialog',
        isOpen: true,
        title: 'Add supplement',
        type: 'product',
        data: data,
        action: 'protocols/addProduct',
        afterAction: {
          name: 'products/getProducts',
          product: this.query
        }
      })
    },
    editSupplement (id, data) {
      console.log(id, data)
      this.TOGGLE_DIALOG({
        id,
        name: 'editSupplementDialog',
        isOpen: true,
        title: 'Edit supplement',
        type: 'product',
        data: data,
        action: 'protocols/updateProtocolSupplement',
        afterAction: {
          name: 'products/getProducts',
          product: this.query
        }
      })
    },
    async deleteSupplement (id, data) {
      await this.TOGGLE_DIALOG({
        id,
        name: 'confirm',
        isOpen: true,
        description: 'Are you sure you want to delete the supplement?',
        action: 'protocols/deleteSupplement',
        afterAction: {
          name: 'products/getProducts',
          product: this.query
        },
        title: 'Confirm deleting the supplement'
      })
    },
    handlerUpdateProtocolSelect (id, value) {
      this.updateProtocolSelect({ id, value })
    }
  },
  computed: {
    ...mapState('products', {
      headers (state) {
        const headers = Object.assign([], state.products?.headers?.$values)
        headers.push({ text: 'Actions', value: 'actions', isSlotable: true, width: '1%', sortable: false })
        return headers?.map(el => ({
          ...this._.omit(el, ['skip', '$id']),
          isSlotable: IS_SLOTABLE.includes(el.value),
          width: (this._.isNumber(el.width)) ? el.width + '%' : el.width
        })).filter(item => item.text !== 'Discontinued')
      },
      itemsProducts (state) {
        const items = Object.assign([], state.products?.data?.$values)
        return items
      }
    }),
    ...mapState({
      visit: state => state.visits?.visit
    }),
    organization () {
      return this.$store.state.organizations.organization
    },
    pageCountProtocol () {
      // const division = this.total > 100 ? 100 : this.itemsPerPage
      return (this.itemsPerPage) ? Math.ceil(this.total / this.itemsPerPage) : 1// return (this.itemsPerPage) ? Math.ceil(this.total / division) : 1
    },
    rowPerPageItems: () => ([5, 10, 15, 20, 'All']),
    actions () {
      return [
        { icon: 'mdi-pencil', color: 'primary', name: 'Edit', action: this.editProductDialog },
        { icon: 'mdi-trash-can-outline', color: 'red', name: 'Delete', action: this.deleteProtocol }
      ]
    },
    actionsSupplement () {
      return [
        { icon: 'mdi-pencil', color: 'primary', name: 'Edit', action: this.editSupplement },
        { icon: 'mdi-trash-can-outline', color: 'red', name: 'Delete', action: this.deleteSupplement }
      ]
    },
    results () {
      return this.$store.state?.results?.results
    },
    protocols () {
      return this.$store.state?.protocols?.protocols
    },
    getAllFunc: () => GET_ALL_PRODUCTS,
    dialogs () {
      return this.$store.state.dialogs
    },
    total () {
      return this.$store.state.products.products.pagination?.total
    },
    productsListIsLoaded () {
      return this.$store.state.products?.productsListIsLoaded
    }
  },
  watch: {
    productsListIsLoaded (val) {
      if (val) {
        this.$refs.productTable.$el.classList.add('paddingBottom')
        this.loading = false
      } else {
        this.loading = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-dialog {
  ::v-deep .v-dialog__container {
    .v-dialog__content .v-dialog {
      overflow: hidden;
      .v-card {
        //padding: 10px;
        &__text {
          padding: 0 24px 20px !important;
          overflow-y: scroll;
          max-height: 80vh;
        }
        &__title {
          padding: 25px 10px 7px 16px !important;
          background: #edf2f7;
          position: relative;
          justify-content: end!important;
          .v-icon {
            bottom: 0!important;
            right: 10px!important;
          }
        }
      }
    }
  }

  .loading {
    height: 100%;
    min-height: 100px;
    position: absolute;
    width: 100%;
    top: 0;
    background: rgb(213 213 213 / 50%);
    border-radius: 16px;
  }
  ::v-deep .confirm-dialog {
    .v-dialog {
      overflow: hidden;
      height: auto!important;
      .v-card {
        &__actions {
          div {
            margin-top: 10px;
          }
        }
      }
    }
  }
  .protocols {
    &__total {
      font-size: 20px;
      font-weight: 600;
      span.num {
        color: $dark-green;
      }
    }
  }
  .label {
    font-size: 14px;
    font-weight: 500;
    color: #425466
  }
  .main-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .title {
    font-weight: 600;
    font-size: 28px;
    text-align: center;
    color: #27272E;
  }
  .product-table {
    width: 100%;
    .is-discontinued {
      background-color: #e7e7e7;
    }
    .is-default {
      background-color: #008c725c;
    }
    ::v-deep .v-card {
      height: auto!important;
    }
    ::v-deep .v-data-table-header th + th {
      border-left:thin solid #0000001f !important;
    }
    ::v-deep th {
      height: 38px!important;
    }
    ::v-deep td {
      border-bottom:thin solid #0000001f !important;
    }
    ::v-deep td + td {
      border-left:thin solid #0000001f !important;
    }
    ::v-deep tr:last-child {
      border-bottom:thin solid #0000001f !important;
    }
    &__row {
      cursor: pointer;
      .name, .notes {}
    }
    //&__row:hover {
    //  background-color: #008c8921!important;
    //}
    &__row:last-child {
      td {
        border-bottom:thin solid #0000001f
      }
    }
    .product-supplement {
      padding: 10px 0;
      ::v-deep .v-card {
        background: #EDF2F7;
        padding: 16px;
        .table {
          padding: 0px!important;
          .v-data-table .v-data-table__wrapper {
            table {
              td + td {
                border-left:thin solid #0000001f;
              }
              td {
                border-bottom:thin solid #0000001f;
              }
              tr:last-child {
                td {
                  border-bottom:unset!important;
                }
              }
              .sub-row {
                .table {
                  padding: 0!important;
                }
                th {
                  padding-top: 15px;
                  padding-bottom: 15px;
                }
                tr:last-child {
                  td {
                    border-bottom: unset;
                  }
                }
                td {
                  //border-bottom: unset;
                }
              }
            }
          }
        }
      }
      .circle-dot {
        height: 8px;
        width: 8px;
        background-color: grey;
        border-radius: 50%;
        display: inline-block;
        margin: 0 2px;
      }
      .circle-dot.light-green {
        background-color: #75DC98!important;
      }
      .circle-dot.light-orange {
        background-color: #F7936F!important;
      }
      .circle-dot:first-child {
        margin-left: 10px;
      }
      .circle-dot:last-child {
        margin: 0 0 0 2px;
      }
      .circle-dot.dark-green {
        background-color: #28605A!important;
      }
      .circle-dot.green {
        background-color: #499D66!important;
      }
      .circle-dot.dark-orange {
        background-color: #F16063!important;
      }
      .circle-dot.light-blue {
        background-color: #00E0FF!important;
      }
      .circle-dot.blue {
        background-color: #537CFF!important;
      }
    }
    .custom-result-table__dynamic.selected-row {
      background: #E9FFFB;
    }
    .custom-result-table__dynamic {
      .selected {
        margin: 0;
        padding: 0;
        ::v-deep .v-input {
          .v-input__slot {
            margin: 0;
          }
          .v-messages {
            display: none;
          }
        }
      }
    }
  }
  .footer {
    height: 60px;
    ::v-deep .v-input {
      .v-messages {
        //display: none;
      }
    }
    .row-per-page {
      font-size: 14px;
      color: #718096;
      &__list {
        width: 60px;
      }
      ::v-deep .v-menu__content {
        min-width: 62px !important;
        .v-list-item {
          &__title {
            display: flex;
            justify-content: center;
          }
        }
      }
      ::v-deep .v-input {
        padding-top: 0px!important;
        margin-top: 0px!important;
        &__slot {
          margin: 0 !important;
        }
        &__append-inner {
          margin-left: 0;
          padding-left: 0;
          margin-top: 2px !important;
        }
      }
      ::v-deep .v-select {
        input {
          display: none;
        }
        &__selection {
          font-size: 14px;
          color: #718096;
        }
        &__selections {
          flex: unset !important;
          line-height: 17px;
          margin-left: 5px;
        }
      }
      .select {
        ::v-deep .v-input {
          &__control {
            .v-text-field__details {
              display: none!important;
            }
          }
        }
      }
    }
    ::v-deep .v-input {
      &__slot {
        margin: 0 !important;
      }
    }
  }
  .paddingBottom {
    padding-bottom: 0px!important;
  }
}
</style>
